import React, { useState } from 'react'
import { getImages } from '../components/Common/const'
const wmJourney = [
    {
        year: '1920',
        content: 'Mark was born in Odessa, Russia, as an only child.',
    },
    {
        year: '1931',
        content: 'Mark had made his way to Chicago and begins providing for his parents at 11 years old.  At the age of 15 Mark bought his first used car for $50. Mark sold that car for $250 to a used car dealer by the name of Tex Sweetlove. Tex liked what he saw in Mark and hired him to buy cars for',
    },
    {
        year: '1948',
        content: 'After serving in the US Army as a celestial navigator and translator (he spoke five languages by this time), Mark opened his first one car used car lot on Cicero Ave in downtown Chicago. Mark would buy one car at a time and when he sold that car he would buy another one with the proceeds.',
    },
    {
        year: '1957',
        content: 'Mark decided to take the money he had earned over a 9 year period and build a used car dealership in the Chicago suburb of Arlington Heights. He named his new dealership Mark Motors.  When the building was complete, the Arlington Heights city manager walked in and advised Mark',
    },
    {
        year: '1959',
        content: 'A company from Germany by the name of Mercedes-Benz was trying to build a dealer network in the US. Their first order of business was to begin to rent warehouse space from Studebaker in Indiana while a man by the name of Hanz Weiztineiger travelled the US in',
    },
    {
        year: '1960',
        content: 'That year a man came up from Indiana to buy the 1959 black 190D Mercedes. The man gave Mark a check for $7,000 and Mark got in touch with Hans to let him know he sold the car. Hans came into the dealership to pick up the $7,000 check and gave Mark a check back.',
    },
    {
        year: '1979',
        content: 'Over the years, Mark sold a few new Mercedes-Benz while selling many used cars. Eventually, Mark also was granted a Chrysler dealership and was successful until 1979 when he voluntarily terminated his franchise to become an exclusive Mercedes-Benz dealer.',
    },
    {
        year: '1981',
        content: 'Mark became the largest Mercedes-Benz dealer in all the Midwest outselling almost every other MB dealer in the country. Mark even sold more Mercedes in one year in Lexington, Kentucky, than the Mercedes dealer in Lexington, Kentucky, did in that same year',
    },
    {
        year: '2002',
        content: 'Mark was told by the manufacturer that it was time to move his dealership to a new location. Around this time, Marks son Ron started to fly to Chicago from San Antonio every week to help with the dealership. Mark was 82 years old and Ron knew his dad needed some help running the day to day',
    },
    {
        year: '2005',
        content: 'MBUSA granted Ron, his sister, Marka, and his brother, Larry, the right to relocate to Texas, and on May 24th, 2005, Mercedes-Benz of Boerne opened its doors for business. Mark got to see the new dealership towards the remaining few days of his life and as he stood in the showroom',
    },
    {
        year: '2017',
        content: 'Ron and Bill set out to build a luxury preowned dealership designed to deliver the very best service in the industry. After careful thought and consideration, they chose the name Mark Motors in honor of Mark for',
    },
    {
        year: '2025',
        content: 'Mark Motors opens an additional second location in Austin, TX',
    },
]
const WhoIsMark = () => {
    const CHARACTER_LIMIT = 260;
    const [expanded, setExpanded] = useState({});

    const toggleReadMore = (index) => {
        setExpanded((prevState) => ({
            ...prevState,
            [index]: !prevState[index],
        }));
    };
    return (
        <>
            <section className='common-banner-wrap mob-h-240 position-relative'>
                <img src={getImages('who-is-mark-banner.webp')} />
                <div className='cb-pos'>
                    <div className='xl-title text-uppercase wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.4s">Who is Mark?</div>
                </div>
            </section>
            <section className='who-mark-wrap'>
                <div className='container mxw-1130'>
                    <div className='sm-title fw-400 font-1-5em text-uppercase text-center wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.4s">Mark Motors where our commitment to you, the customer, is the same as it was when Mark opened the original Mark Motors back in <span className='text-blue'>1957</span></div>
                    <div className='wm-journey-block'>
                        {wmJourney.map((item, index) => {
                            const isExpanded = expanded[index];
                            const content = item.content.length > CHARACTER_LIMIT
                                ? isExpanded
                                    ? item.content
                                    : `${item.content.slice(0, CHARACTER_LIMIT)}...`
                                : item.content;

                            return (
                                <div className='d-flex wmj-box wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.3s" key={index}>
                                    <div className='wm-year-box'>{item.year}</div>
                                    <div className='sm-title'>
                                        {content}
                                        {item.content.length > CHARACTER_LIMIT && (
                                            <span
                                                className="text-blue cursor-pointer"
                                                onClick={() => toggleReadMore(index)}
                                            >
                                                {isExpanded ? ' Less' : ' More'}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    <div className='text-center ab-logo pt-4'>
                        <img src={getImages('mm-logo-white.webp')} />
                    </div>
                </div>
            </section>
        </>
    )
}

export default WhoIsMark